/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Anonymise_WarningInputs */

const cs_gdpr_anonymise_warning = /** @type {(inputs: Gdpr_Anonymise_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymizace je nevratná. Osobní údaje se smažou, záznam zůstane kvůli obchodům a statistikám.`)
};

const en_gdpr_anonymise_warning = /** @type {(inputs: Gdpr_Anonymise_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymisation is irreversible. Personal data is erased; the record shell stays for deals and statistics.`)
};

/**
* | output |
* | --- |
* | "Anonymisation is irreversible. Personal data is erased; the record shell stays for deals and statistics." |
*
* @param {Gdpr_Anonymise_WarningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_anonymise_warning = /** @type {((inputs?: Gdpr_Anonymise_WarningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Anonymise_WarningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_anonymise_warning(inputs)
	return cs_gdpr_anonymise_warning(inputs)
});